/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { NumericValueWithUnitDto } from './NumericValueWithUnitDto';
import {
    NumericValueWithUnitDtoFromJSON,
    NumericValueWithUnitDtoFromJSONTyped,
    NumericValueWithUnitDtoToJSON,
} from './NumericValueWithUnitDto';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';
import type { CreateDefinitionDtoValueType } from './CreateDefinitionDtoValueType';
import {
    CreateDefinitionDtoValueTypeFromJSON,
    CreateDefinitionDtoValueTypeFromJSONTyped,
    CreateDefinitionDtoValueTypeToJSON,
} from './CreateDefinitionDtoValueType';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface NumericDataSetFilterDto
 */
export interface NumericDataSetFilterDto {
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetFilterDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetFilterDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetFilterDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetFilterDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NumericDataSetFilterDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NumericDataSetFilterDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {CreateDefinitionDtoValueType}
     * @memberof NumericDataSetFilterDto
     */
    valueType?: CreateDefinitionDtoValueType | null;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof NumericDataSetFilterDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof NumericDataSetFilterDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<NumericValueWithUnitDto>}
     * @memberof NumericDataSetFilterDto
     */
    selectedValues?: Array<NumericValueWithUnitDto> | null;
    /**
     * 
     * @type {Array<NumericValueWithUnitDto>}
     * @memberof NumericDataSetFilterDto
     */
    availableValues?: Array<NumericValueWithUnitDto> | null;
    /**
     * 
     * @type {string}
     * @memberof NumericDataSetFilterDto
     */
    $type?: NumericDataSetFilterDtoTypeEnum;
}


/**
 * @export
 */
export const NumericDataSetFilterDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoNumericDataSetFilterDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataSetFilterDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NumericDataSetFilterDtoTypeEnum = typeof NumericDataSetFilterDtoTypeEnum[keyof typeof NumericDataSetFilterDtoTypeEnum];



/**
 * Check if a given object implements the NumericDataSetFilterDto interface.
 */
export function instanceOfNumericDataSetFilterDto(value?: unknown): value is NumericDataSetFilterDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericDataSetFilterDtoTypeEnum)[0];
}

export function NumericDataSetFilterDtoFromJSON(json: any): NumericDataSetFilterDto {
    return NumericDataSetFilterDtoFromJSONTyped(json, false);
}

export function NumericDataSetFilterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericDataSetFilterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'decimalPlaces': json['decimalPlaces'] == null ? undefined : json['decimalPlaces'],
        'valueType': json['valueType'] == null ? undefined : CreateDefinitionDtoValueTypeFromJSON(json['valueType']),
        'geometry': json['geometry'] == null ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'selectedValues': json['selectedValues'] == null ? undefined : ((json['selectedValues'] as Array<any>).map(NumericValueWithUnitDtoFromJSON)),
        'availableValues': json['availableValues'] == null ? undefined : ((json['availableValues'] as Array<any>).map(NumericValueWithUnitDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function NumericDataSetFilterDtoToJSON(value?: NumericDataSetFilterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'name': value['name'],
        'iuid': value['iuid'],
        'isEnabled': value['isEnabled'],
        'decimalPlaces': value['decimalPlaces'],
        'valueType': CreateDefinitionDtoValueTypeToJSON(value['valueType']),
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value['geometry']),
        'origin': EntityOriginToJSON(value['origin']),
        'selectedValues': value['selectedValues'] == null ? undefined : ((value['selectedValues'] as Array<any>).map(NumericValueWithUnitDtoToJSON)),
        'availableValues': value['availableValues'] == null ? undefined : ((value['availableValues'] as Array<any>).map(NumericValueWithUnitDtoToJSON)),
        '$type': value['$type'],
    });
}

